// 15-minute time grid.
export const HOURS_QUANTUM = 1 / 4;

export const snapToQuantum = (hours: number): number => {
    if (hours <= 0) {
        return 0;
    }
    return Math.round(hours / HOURS_QUANTUM) * HOURS_QUANTUM;
};

export const parseHM = (raw: string): number | null => {
    const s = raw.trim();
    if (!s) {
        return null;
    }
    const colon = s.match(/^(\d+):(\d{1,2})$/);
    if (colon) {
        const h = Number(colon[1]);
        const m = Number(colon[2]);
        if (!Number.isFinite(h) || !Number.isFinite(m) || m < 0 || m >= 60) {
            return null;
        }
        return h + m / 60;
    }
    const n = Number.parseFloat(s);
    if (Number.isFinite(n) && n >= 0) {
        return n;
    }
    return null;
};

// Format at minute precision — don't snap to the quantum. New entries
// land on the 15-min grid via `snapToQuantum`; older 5-min (or off-grid)
// entries from before the quantum change must keep their real value
// (e.g. 2.5833h shows as 2:35, not 2:30).
export const formatHM = (hours: number): string => {
    if (hours === 0) {
        return '0:00';
    }
    const sign = hours < 0 ? '-' : '';
    const totalMinutes = Math.round(Math.abs(hours) * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${sign}${h}:${String(m).padStart(2, '0')}`;
};

export const formatHhMm = (hours: number, opts: { alwaysShowMinutes?: boolean } = {}): string => {
    if (hours === 0) {
        return opts.alwaysShowMinutes ? '0h 00m' : '0h';
    }
    const sign = hours < 0 ? '-' : '';
    const totalMinutes = Math.round(Math.abs(hours) * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    if (m === 0 && !opts.alwaysShowMinutes) {
        return `${sign}${h}h`;
    }
    if (h === 0) {
        return `${sign}${m}m`;
    }
    return `${sign}${h}h ${String(m).padStart(2, '0')}m`;
};
